export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-phishingchecker",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2022-05-25 09:53+0200",
	"Last-Translator": "",
	Language: "de_DE",
	"Language-Team": "NAME <EMAIL>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 3.0.1"
};
export default {
	headers: headers,
	"\u0000Anti-phishing Protection\u0001": [
	"Anti-Phishing-Schutz"
],
	"\u0000You are attempting to open a potentially insecure link. Are you sure you want to proceed?\u0001": [
	"Sie sind im Begriff, einen potenziell unsicheren Link zu öffnen. Möchten Sie wirklich fortfahren?"
],
	"\u0000Open Link\u0001": [
	"Link öffnen"
],
	"\u0000Cancel\u0001": [
	"Abbrechen"
],
	"\u0000Invalid URL\u0001": [
	"Ungültige URL"
],
	"\u0000URL you want to open is invalid. Cannot proceed.\u0001": [
	"Die URL, die Sie öffnen möchten, ist ungültig. Fortfahren nicht möglich."
],
	"\u0000Anti-phishing Protection is scanning your link...\u0001": [
	"Ihr Link wird durch den Anti-Phishing-Schutz geprüft..."
],
	"\u0000Phishing is the fraudulent attempt to obtain sensitive information or data, such as usernames, passwords and credit card details by directing users to enter their personal information at fake websites that look legitimate.\u0001": [
	"Phishing ist der betrügerische Versuch, vertrauliche Informationen oder Daten wie Benutzernamen, Passwörter und Kreditkartendaten zu erhalten, indem Benutzer angewiesen werden, ihre persönlichen Daten auf gefälschten Websites einzugeben, die legitim aussehen."
],
	"\u0000Anti-phishing protection will scan links in emails you receive to determine if it is safe for you to visit.\u0001": [
	"Beim Anti-Phishing-Schutz werden Links in von Ihnen empfangenen E-Mails geprüft, um festzustellen, ob sie gefahrlos aufgerufen werden können."
],
	"\u0000Do not scan links in emails I receive.\u0001": [
	"Keine Links in von mir empfangenen E-Mails prüfen."
],
	"\u0000Only scan links in emails I receive within %s.\u0001": [
	"Nur Links in E-Mails prüfen, die ich in %s empfange."
],
	"\u0000Scan all links in emails I receive within %s and on third-party and mobile devices.\u0001": [
	"Alle Links prüfen in E-Mails, die ich in %s und auf Geräten von Drittanbietern und Mobilgeräten empfange."
],
	"\u0000Scan links in emails I receive within %s.\u0001": [
	"Links in E-Mails prüfen, die ich in %s empfange."
],
	"\u0000Please select your level of protection:\u0001": [
	"Bitte wählen Sie Ihr Schutzniveau aus:"
],
	"\u0000Anti-Phishing\u0001": [
	"Anti-Phishing"
]
};
